import Action from '@/dataAccess/dto/Action'
import { TimeRange, union, intersection } from '@/services/timerange'

export default function calculateDailyWorkHours(
  actions: [Action],
  date: string
): number {
  const actionIntervals = actions
    .filter(a => a.timed)
    .map(a => new TimeRange(a.start, a.end))
  const firstMomentOfDay = new Date(date)
  firstMomentOfDay.setHours(0, 0, 0, 0)
  const lastMomentOfDay = new Date(date)
  lastMomentOfDay.setHours(23, 59, 59, 999)
  const dateInterval = new TimeRange(firstMomentOfDay, lastMomentOfDay)
  const worktimeDuringDate = intersection(
    union(...actionIntervals),
    dateInterval
  )
  return worktimeDuringDate.length / 3600000
}
